<template>
  <div
    :class="[
      $style.wrapper,
      isActive && $style.isActive
    ]"
    @click="$emit('click')"
  >
    <BaseAvatar
      :url="imageUrl"
      :size="32"
    />
    {{ name[$i18n.locale] || name['en'] }}&nbsp;
    <span :class="$style.vsText">
      <template v-if="isTeamAtHome">{{ $t('vs') }}&nbsp;</template>
      <template v-else>{{ $t('at') }}&nbsp;</template>
    </span>
    <span :class="$style.team2name">
      {{ team2name[$i18n.locale] || team2name['en'] }}
    </span>
  </div>
</template>

<script>
import BaseAvatar from '@/components/Atoms/BaseAvatar'
export default {
  name: 'BaseTeamButton',
  components: { BaseAvatar },
  props: {
    name: {
      type: Object,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    team2name: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTeamAtHome: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";

  .wrapper {
    text-align: center;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: .25rem .5rem;
    border-radius: .5rem;
    border: 2px solid  $color-tomato;
    transition: all .25s ease-in-out;
    font-size: $font-size-small;
    color: $color-tomato;
    img {
      margin-right: .5rem;
    }
    &.isActive {
      background-color: $color-tomato;
      color: $color-white;
    }
    &:hover {
      background-color: darken($color-tomato, 5%);
      color: $color-white;
    }
  }
</style>
